<div class="container-fluid">
  <div class="page-head">
    @if (showHeader) {
      <h1 class="page-title">Sites</h1>
    } @else {
      <div></div>
    }
    <div class="action-row">
      <div class="form-check d-flex align-items-center m-0">
        <input
          class="form-check-input me-1"
          id="showDeactivated"
          type="checkbox"
          (change)="onShowDeactivatedSitesChange()"
          [checked]="showDeactivated"
        />
        <label class="form-check-label m-0" for="showDeactivated">
          Show deactivated sites?
        </label>
      </div>
      @if (
        LoggedInUser &&
        acceptedActionRoles.includes(
          $safeNavigationMigration(LoggedInUser.UserAccountRole?.role)!
        )
      ) {
        <button class="btn btn-primary" (click)="addSite()">Add site</button>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-12 pt-3" style="height: 500px">
      <app-sites-grid
        [gridName]="'ClientMySites'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [suppliedQueryData]="suppliedQueryData"
        [getCalculatedColumnActions]="getCalculatedColumnActions"
        [TooltipMap]="TooltipMap"
        [(reloadGridData)]="reloadGrid"
        (actionEvent)="action($event)"
      ></app-sites-grid>
    </div>
  </div>
</div>
